import ActionIcons from '@/components/service-log/action-icons/action-icons.vue';
import SubmissionHistory from '../submission-history-dialog/submission-history-dialog.vue';

export default {
  name: 'HistoryRepeatable',
  components: {
    ActionIcons,
    SubmissionHistory
  },
  props: ['submission', 'loadData'],
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  data() {
    return {
      confirmationDialog: false,
      date: {
        month: '',
        date: '',
        year: ''
      }
    };
  },
  methods: {
    showDialog() {
      this.confirmationDialog = true;
    },
    setDate() {
      const [year, month, date] = this.submission.sessionDate.split('-');
      this.date.year = year;
      this.date.month = month;
      this.date.date = date;
      switch (month.toString()) {
        case '01':
          this.date.month = 'January';
          break;
        case '02':
          this.date.month = 'February';
          break;
        case '03':
          this.date.month = 'March';
          break;
        case '04':
          this.date.month = 'April';
          break;
        case '05':
          this.date.month = 'May';
          break;
        case '06':
          this.date.month = 'June';
          break;
        case '07':
          this.date.month = 'July';
          break;
        case '08':
          this.date.month = 'August';
          break;
        case '09':
          this.date.month = 'September';
          break;
        case '10':
          this.date.month = 'October';
          break;
        case '11':
          this.date.month = 'November';
          break;
        default:
          this.date.month = 'December';
          break;
      }
    },
    deleteServiceLog() {
      this.$emit('service-log:deleted');
    }
  },
  mounted() {
    this.setDate();
  },
  watch: {
    loadData() {
      this.setDate();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/history/history-repeatable/history-repeatable.js